import blankEnvelope from '../../assets/Blank.webp';
import recipientStepEnvelope from '../../assets/Recipient_step.webp';
import returnEnvelope from '../../assets/ReturnAddress.webp';
import returnStepEnvelope from '../../assets/Return_step.webp';
import returnRecipientEnvelope from '../../assets/Return_wRecipient.webp';
import returnOnlyEnvelope from '../../assets/return_only-envelope.webp';
import { AddressTypes } from '../../global-types';
import { EnvelopeType, SelectedEnvelope, SelectedEnvelopePreview } from '../../global-types/envelope';

export const ENVELOPES: SelectedEnvelope[] = [
  {
    key: EnvelopeType.Blank,
    image: blankEnvelope,
  },
  {
    key: EnvelopeType.Return,
    image: returnEnvelope,
  },
  {
    key: EnvelopeType.ReturnRecipient,
    image: returnRecipientEnvelope,
  },
];

export const MARKED_ENVELOPES: SelectedEnvelopePreview = {
  [EnvelopeType.ReturnRecipient]: {
    [AddressTypes.SENDER]: {
      key: AddressTypes.SENDER,
      image: returnStepEnvelope,
    },
    [AddressTypes.RECIPIENT]: {
      key: AddressTypes.RECIPIENT,
      image: recipientStepEnvelope,
    },
  },
  [EnvelopeType.Return]: {
    [AddressTypes.SENDER]: {
      key: AddressTypes.SENDER,
      image: returnOnlyEnvelope,
    },
  },
};
